import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center bg-architectural-pattern overflow-hidden pt-20" data-id="element-149">
      {/* Overlay gradient for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-forest/80 via-forest/90 to-forest z-0" data-id="element-150"></div>

      {/* Decorative geometric lines */}
      <div className="absolute inset-0 opacity-20 pointer-events-none z-0 flex items-center justify-center" data-id="element-151">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-152">
          <defs data-id="element-153">
            <pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse" data-id="element-154">
              <path d="M 100 0 L 0 0 0 100" fill="none" stroke="#C4A35A" strokeWidth="0.5" data-id="element-155" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-156" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-158">
          <span className="inline-block py-1 px-3 rounded-full bg-gold/20 text-gold text-sm font-semibold tracking-wider mb-6 uppercase" data-id="element-159">
            Experience The Future of Homebuilding
          </span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-cream mb-6 text-balance leading-tight" data-id="element-160">
            Build the Home You've Always Imagined
          </h1>
          <p className="text-xl md:text-2xl text-cream/80 mb-10 max-w-2xl mx-auto font-light" data-id="element-161">
            Explore floor plans, choose finishes, and walk through your home in
            3D — before it's built.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-162">
            <Button to="/experience" size="lg" className="text-lg px-8" data-id="element-163">
              Design Your Dream Home
            </Button>
            <Button href="#floor-plans" variant="outline" size="lg" className="text-lg px-8 border-cream text-cream hover:bg-cream hover:text-forest" data-id="element-164">
              View Floor Plans
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 flex flex-col items-center" data-id="element-165">
        <span className="text-cream/60 text-sm mb-2 uppercase tracking-widest" data-id="element-166">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-gold to-transparent" data-id="element-167"></div>
      </motion.div>
    </section>;
}